import { useViewerStateStore } from "../../store/viewerStateStore";
import { useTranslation } from "react-i18next";

// TODO: Combine with purely functional LoadingStateComponent?
const LoadingStateVisualizerComponent = () => {
    const { loadingState } = useViewerStateStore();
    const { t } = useTranslation();

    return (
        <>



            {loadingState === "Loading" && t("ui.loadingState.loading")}
            {loadingState === "Loaded" && ""}
            {loadingState === "Error" &&    t("ui.loadingState.error")}
            {loadingState === "Initial" &&  t("ui.loadingState.initial")}
        </>
    );
};

export default LoadingStateVisualizerComponent;